var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],ref:"input",attrs:{"value":_vm.time,"label":_vm.label,"prepend-icon":_vm.icon,"disabled":_vm.disabled,"rules":_vm.allRules,"outlined":_vm.outlined,"dense":_vm.dense},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }